import { memo } from "react";

function VoidedMarker(props) {
  const { backgroundColor = "#D54040", borderColor="white", size = 27 } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_10100_47002)">
        <path
          d="M22 0H2C0.89543 0 0 0.89543 0 2V22C0 23.1046 0.89543 24 2 24H22C23.1046 24 24 23.1046 24 22V2C24 0.89543 23.1046 0 22 0Z"
          fill={backgroundColor}
        />
        <path
          d="M4.5 19.5H19.5V4.5H4.5V19.5ZM4.5 21C4.08333 21 3.72917 20.8542 3.4375 20.5625C3.14583 20.2708 3 19.9167 3 19.5V4.5C3 4.08333 3.14583 3.72917 3.4375 3.4375C3.72917 3.14583 4.08333 3 4.5 3H19.5C19.9167 3 20.2708 3.14583 20.5625 3.4375C20.8542 3.72917 21 4.08333 21 4.5V19.5C21 19.9167 20.8542 20.2708 20.5625 20.5625C20.2708 20.8542 19.9167 21 19.5 21H4.5ZM7.875 16.125C8.025 16.275 8.2 16.35 8.4 16.35C8.6 16.35 8.775 16.275 8.925 16.125L12 13.05L15.075 16.125C15.225 16.275 15.4 16.35 15.6 16.35C15.8 16.35 15.975 16.275 16.125 16.125C16.275 15.975 16.35 15.8 16.35 15.6C16.35 15.4 16.275 15.225 16.125 15.075L13.05 12L16.125 8.925C16.275 8.775 16.35 8.6 16.35 8.4C16.35 8.2 16.275 8.025 16.125 7.875C15.975 7.725 15.8 7.65 15.6 7.65C15.4 7.65 15.225 7.725 15.075 7.875L12 10.95L8.925 7.875C8.775 7.725 8.6 7.65 8.4 7.65C8.2 7.65 8.025 7.725 7.875 7.875C7.725 8.025 7.65 8.2 7.65 8.4C7.65 8.6 7.725 8.775 7.875 8.925L10.95 12L7.875 15.075C7.725 15.225 7.65 15.4 7.65 15.6C7.65 15.8 7.725 15.975 7.875 16.125ZM4.5 19.5V4.5V19.5Z"
          fill={borderColor}
        />
      </g>
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke={borderColor} />
      <defs>
        <clipPath id="clip0_10100_47002">
          <rect width="24" height="24" rx="2" fill={borderColor} />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(VoidedMarker);
